var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFloppyDisk = function SvgIconFloppyDisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 6.5a1 1 0 0 0 0 2h5.25a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.44 2.75a1.74 1.74 0 0 1 1.231.507l.002.002 4.07 4.07a1.74 1.74 0 0 1 .507 1.232v.002l-1-.004h1V19.5a1.75 1.75 0 0 1-1.75 1.75h-15a1.75 1.75 0 0 1-1.75-1.75v-15A1.75 1.75 0 0 1 4.5 2.75zm-.104 2 3.914 3.914V19.25H17.5v-5a1.75 1.75 0 0 0-1.75-1.75h-7.5a1.75 1.75 0 0 0-1.75 1.75v5H4.75V4.75zm.164 9.75v4.75h-7V14.5z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconFloppyDisk;